import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Link } from "react-router-dom";
import config from "../../../config/common";
import Container from "./Container";
import Row from "./Row";
import SpotName from "./SpotName";
import HeightText from "./HeightText";
import HeightTextLabel from "./HeightTextLabel";
import Time from "./Time";
import ChangeMarkerContainer from "./ChangeMarkerContainer";
import ChangeMarker from "./ChangeMarker";

const BuoySummary = (props) => {
  const { spotName, date, height, peakPeriod, change } = props;
  const period = Number(peakPeriod).toFixed(1);

  //   no decimal if over 10 second period
  //   if (period.length > 3) {
  //     period = Number(peakPeriod).toFixed(0);
  //   }
  return (
    <Container as={Link} to={`/spot/${spotName}`}>
      <Row>
        <SpotName>{spotName}</SpotName>
        {height && (
          <>
            <ChangeMarkerContainer>
              <ChangeMarker change={change} />
            </ChangeMarkerContainer>
            <HeightText>
              {Number(height).toFixed(1)}
              <HeightTextLabel>m</HeightTextLabel>
            </HeightText>
          </>
        )}
      </Row>
      <Row>
        {date && (
          <Time dateTime={date}>
            {moment(date).add(config.timeCorrection, "hours").format("HH:mm")}
          </Time>
        )}
        {peakPeriod && <div>@{period}s</div>}
        {!peakPeriod && !height && !date && (
          <div style={{ fontSize: "0.9rem", paddingTop: 4 }}>Buoy Offline</div>
        )}
      </Row>
    </Container>
  );
};

BuoySummary.propTypes = {
  spotName: PropTypes.string.isRequired,
  date: PropTypes.string,
  height: PropTypes.string,
  peakPeriod: PropTypes.string,
  change: PropTypes.oneOf(["increase", "decrease", "no-change"]),
};

BuoySummary.defaultProps = {
  date: undefined,
  height: undefined,
  peakPeriod: undefined,
  change: "no-change",
};

export default BuoySummary;
